export default "__VITE_ASSET__5P4hVDTk__"